import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 7V4h2V2H4v20h16v-2h-4.03c1.23-.91 2.03-2.36 2.03-4v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v3h10z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "13",
  cy: "9",
  r: "1"
}, "1")], 'CoffeeMakerSharp');